<template>
  <header class="header">
    <div class="header_bg">
      <img :src="$designResource.headerBg" alt />
    </div>
    <div v-if="isHome" class="header_info">
      <a href="javascript:void(0)" @click="goOther" class="header_info_link">
        <img :src="$designResource.headerInfo" alt />
      </a>
    </div>
    <div v-else class="header_info">
      <a href="javascript:void(0)" @click="isLoading ? ()=>{} : goHome()" class="header_info_link">
        <img :src="$designResource.headerHome" alt />
      </a>
    </div>
    <div v-if="title" class="header_title">{{title}}</div>
    <div v-else class="header_text">
      <div class="header_day">{{formatedDate}}</div>
      <div class="header_time">{{formatedTime}}</div>
    </div>
    <div v-if="btnType == 'reload'" class="header_btn_holder">
      <a href="javascript:void(0)" @click="$emit('click_header_btn')" class="header_btn">
        <img :src="$designResource.buttonReload" alt />
      </a>
    </div>
    <div v-else-if="btnType == 'checkout'" class="header_btn_holder">
      <a href="javascript:void(0)" @click="$emit('click_header_btn')" class="header_btn">
        <img :src="$designResource.buttonCheckout" alt />
      </a>
    </div>
    <div v-else-if="btnType == 'checkin'" class="header_btn_holder">
      <a href="javascript:void(0)" @click="$emit('click_header_btn')" class="header_btn">
        <img :src="$designResource.buttonCheckin" alt />
      </a>
    </div>
  </header>
</template>

<script>
import moment from "moment";
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    now: {
      type: Date,
      required: false
    },
    isHome: {
      type: Boolean,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    },
    btnType: {
      type: String,
      required: false
    }
  },
  computed: {
    formatedDate() {
      var momentObj = moment(this.now);
      return (
        momentObj.month() +
        1 +
        "月" +
        momentObj.date() +
        "日 (" +
        momentObj.format("dddd") +
        ")"
      );
    },
    formatedTime() {
      return moment(this.now).format("HH:mm");
    }
  },
  methods: {
    goHome: function() {
      this.$router.push({
        path: `/main`
      });
    },
    goOther: function() {
      this.$router.push({
        path: `/other`
      });
    }
  }
};
</script>

<style lang="scss">
/** ヘッダー **/
.header {
  position: relative;
  margin-bottom: 50px;
}

/** ヘッダー **/
.header.nobottom {
  margin-bottom: 0;
}

.header_bg {
  position: relative;
  z-index: 1;
}

.header_bg > img {
  width: 100%;
  height: 140px;
}

/** infoアイコン **/
.header_info {
  position: absolute;
  top: 30px;
  left: 20px;
  z-index: 10;
}

.header_info_link > img {
  width: 33px;
}

/** 日付＋時間 **/
.header_text {
  position: absolute;
  top: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 5;
}

.header_day {
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 6px;
}

.header_time {
  font-size: 36px;
  color: #ffffff;
}

/** 画面名のみまたは画面名＋更新ボタン **/
.header_title {
  position: absolute;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 30px;
  color: #ffffff;
}

/** ヘッダーボタン **/
.header_btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.header_btn > img {
  width: 78px;
}
.header_btn_holder {
  position: absolute;
  width: 78px;
  height: 78px;
  bottom: -40px;
  left: calc(100% / 2 - 39px);
  z-index: 10;
}
</style>